import { IGetDashboardComercialInformationUseCase } from "../../../presentation/useCases/read/get_dashboard_comercial_information_use_case";
import { DashboardComercial } from "../../models/dashboard_comercial";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetDashboardComercialInformationUseCase
 */

export class GetDashboardComercialInformationUseCase implements IGetDashboardComercialInformationUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async getDashboardComercialInformation(): Promise<DashboardComercial> {
    return await this.repository.getDashboardComercialInformation();
  }
}
